import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Layout/Breadcrumb";

import Form from "./FormStep1";

const New = () => {
  const { t } = useTranslation();

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "/immigration/list",
      label: t("List view"),
      active: false,
    },
    {
      url: "#",
      label: `${t("Create")} ${t("immigration")}`,
      active: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={`${t("Employee Immigration Profile")}`}
            breadcrumbItems={breadcrumbItems}
          />
          <Form id={0} immigration_id={""} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default New;